import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-background-50 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              哈哈漫画网
            </h3>
            <p className="text-sm leading-relaxed text-background-50/60">
              韩国漫画免费在线观看平台，提供高清韩漫全集下拉式阅读服务。收录数千部优质漫画，每日更新，完全免费。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/romance" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/drama" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">剧情漫画</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">搞笑漫画</Link></li>
              <li><Link to="/category/suspense" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">悬疑漫画</Link></li>
              <li><Link to="/category/bl" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">耽美漫画</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">漫画大全</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line"></i>
                <span>contact@hahacomic.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-wechat-line"></i>
                <span>hahacomic2023</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-time-line"></i>
                <span>周一至周日 9:00-21:00</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-50/10 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} 哈哈漫画网 hahaComic.com - 韩国漫画免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}